import { useState } from 'react';

type ImageCarouselProps = {
  images: string[];
  alt?: string;
};

/* Lightweight custom gallery — replaces the old semantic-ui / react-responsive-carousel
   implementation that rendered with broken styling. */
const ImageCarousel = ({ images, alt = '' }: ImageCarouselProps) => {
  const [i, setI] = useState(0);
  const many = images.length > 1;
  const go = (n: number) => setI((n + images.length) % images.length);

  return (
    <div className="gallery">
      <img src={images[i]} alt={alt} loading="lazy" />

      {many && (
        <>
          <span className="gallery-count">{i + 1} / {images.length}</span>
          <button className="gallery-btn prev" aria-label="Previous photo" onClick={() => go(i - 1)}>‹</button>
          <button className="gallery-btn next" aria-label="Next photo" onClick={() => go(i + 1)}>›</button>
          <div className="gallery-dots">
            {images.map((img, idx) => (
              <i key={img} className={idx === i ? 'on' : ''} onClick={() => setI(idx)} />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ImageCarousel;
